/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: dpdRoEHB1RdkpQGeaRP58K
// Component: FsVP2sKr-kJp

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGPresetMessage } from "@lg-plus/landing-components/LGPresetMessage"; // plasmic-import: Dacw2T1iverq/codeComponent
import Slider from "../../Slider"; // plasmic-import: 8Z4dIwJ5cIMM/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: bpjkO1FTcHhf/component
import { LGCTAButton } from "@lg-plus/landing-components"; // plasmic-import: i7C4_EphcVUJ/codeComponent
import PrimaryButton from "../../PrimaryButton"; // plasmic-import: RGug0u2y3_bY/component
import { AntdAccordion } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { accordionHelpers as AntdAccordion_Helpers } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { AntdAccordionItem } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import SliderBtn from "../../SliderBtn"; // plasmic-import: odaypzOMQtOx/component
import Footer from "../../Footer"; // plasmic-import: RjKk5sv3K_6R/component
import { BackToTop } from "@lg-plus/landing-components"; // plasmic-import: bwu1P18GfXO0/codeComponent
import { Fetcher } from "@plasmicapp/react-web/lib/data-sources";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomepage.module.css"; // plasmic-import: FsVP2sKr-kJp/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: pXZKqhpBDNG1/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: PVKY5o0iveVJ/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "Oblíbená půjčka",
    description: "Schválení půjčky do 15 minut.",
    openGraph: {
      title: "Oblíbená půjčka",
      description: "Schválení půjčky do 15 minut."
    },
    twitter: {
      card: "summary" as const,
      title: "Oblíbená půjčka",
      description: "Schválení půjčky do 15 minut."
    }
  };
}

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  homePageWrapper?: Flex__<"div">;
  lgPresetMessage?: Flex__<typeof LGPresetMessage>;
  header?: Flex__<"div">;
  slider?: Flex__<typeof Slider>;
  faq?: Flex__<"div">;
  accordion?: Flex__<typeof AntdAccordion>;
  reviews?: Flex__<"div">;
  sliderCarousel?: Flex__<typeof SliderWrapper>;
  reviewSlide?: Flex__<"div">;
  reviewCard?: Flex__<"div">;
  reviewCard2?: Flex__<"div">;
  reviewSlide2?: Flex__<"div">;
  reviewCard3?: Flex__<"div">;
  reviewCard4?: Flex__<"div">;
  reviewSlide3?: Flex__<"div">;
  reviewCard5?: Flex__<"div">;
  reviewCard6?: Flex__<"div">;
  footer?: Flex__<typeof Footer>;
  backToTop?: Flex__<typeof BackToTop>;
};

export interface DefaultHomepageProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 17000
      },
      {
        path: "slider.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $state.amount
      },
      {
        path: "accordion.activePanelId",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec(
          "activePanelId",
          AntdAccordion_Helpers
        )
      },
      {
        path: "sliderCarousel.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "sliderCarousel",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
        <meta
          key="description"
          property="description"
          content={pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={pageMetadata.description}
        />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={pageMetadata.description}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"homePageWrapper"}
          data-plasmic-override={overrides.homePageWrapper}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_dpdRoEHB1RdkpQGeaRP58K",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.homePageWrapper
          )}
        >
          <LGPresetMessage
            data-plasmic-name={"lgPresetMessage"}
            data-plasmic-override={overrides.lgPresetMessage}
            className={classNames("__wab_instance", sty.lgPresetMessage)}
            content={
              "Tento odkaz je neplatn\u00fd nebo jeho platnost vypr\u0161ela."
            }
            isDynamic={true}
            preset={"INVALID_LINK"}
          />

          <div
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("all", sty.header, "header-custom-bg")}
          >
            <div className={classNames("all", sty.freeBox__oA15)}>
              <div className={classNames("all", sty.freeBox__q71Wz)}>
                <div className={classNames("all", sty.freeBox__h3Eq8)}>
                  <div className={classNames("all", sty.freeBox___6P4T)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__rrQ99)}
                      displayHeight={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? "40px"
                          : "auto"
                      }
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={{
                        src: "/plasmic/oblibena/images/oblibenaSvg.svg",
                        fullWidth: 190,
                        fullHeight: 60,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__hgrDk)}>
                    <div className={classNames("all", sty.freeBox__pZV9)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__cW2UX
                        )}
                      >
                        {"Rychl\u00e1 a bezpe\u010dn\u00e1"}
                      </div>
                    </div>
                    <div className={classNames("all", sty.freeBox__oiLlr)}>
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__hnvSw
                        )}
                      >
                        {"p\u016fj\u010dka na cokoliv"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classNames("all", sty.freeBox__vJvnQ)}>
                <div className={classNames("all", sty.freeBox__ygyRt)}>
                  <Slider
                    data-plasmic-name={"slider"}
                    data-plasmic-override={overrides.slider}
                    className={classNames("__wab_instance", sty.slider)}
                    label={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__rMds
                        )}
                      >
                        {"Chci si p\u016fj\u010dit:"}
                      </div>
                    }
                    maxValue={30000}
                    minValue={1000}
                    onChange={async (...eventArgs: any) => {
                      generateStateOnChangeProp($state, [
                        "slider",
                        "value"
                      ]).apply(null, eventArgs);

                      if (
                        eventArgs.length > 1 &&
                        eventArgs[1] &&
                        eventArgs[1]._plasmic_state_init_
                      ) {
                        return;
                      }

                      (async val => {
                        const $steps = {};

                        $steps["updateAmount"] = true
                          ? (() => {
                              const actionArgs = {
                                variable: {
                                  objRoot: $state,
                                  variablePath: ["amount"]
                                },
                                operation: 0,
                                value: $state.slider.value
                              };
                              return (({
                                variable,
                                value,
                                startIndex,
                                deleteCount
                              }) => {
                                if (!variable) {
                                  return;
                                }
                                const { objRoot, variablePath } = variable;

                                $stateSet(objRoot, variablePath, value);
                                return value;
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["updateAmount"] != null &&
                          typeof $steps["updateAmount"] === "object" &&
                          typeof $steps["updateAmount"].then === "function"
                        ) {
                          $steps["updateAmount"] = await $steps["updateAmount"];
                        }
                      }).apply(null, eventArgs);
                    }}
                    step={1000}
                    value={generateStateValueProp($state, ["slider", "value"])}
                  />

                  <div
                    className={classNames("all", "__wab_text", sty.text__jwJ0I)}
                  >
                    {
                      "Ide\u00e1ln\u00ed p\u016fj\u010dka na\u0161ich z\u00e1kazn\u00edk\u016f je 20 000 K\u010d v d\u00e9lce od 3 do 36 m\u011bs\u00edc\u016f, s \u00farokem 2,99% p. a., Max. RPSN 4,39%. M\u011bs\u00ed\u010dn\u00ed spl\u00e1tka 594 K\u010d. Celkem k zaplacen\u00ed 24 967 K\u010d. V\u00fdpo\u010det je pouze ilustrativn\u00ed, kone\u010dn\u00fd \u00farok ur\u010d\u00ed poskytovatel."
                    }
                  </div>
                  <div className={classNames("all", sty.freeBox__coV4R)}>
                    <LGCTAButton
                      amount={$state.amount}
                      buttonSlot={
                        <PrimaryButton
                          className={classNames(
                            "__wab_instance",
                            sty.primaryButton__w5U2C
                          )}
                          label={
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text___1YaGi
                              )}
                            >
                              {"Z\u00cdSKAT PEN\u00cdZE"}
                            </div>
                          }
                        />
                      }
                      className={classNames(
                        "__wab_instance",
                        sty.lgctaButton__ga0Y5
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classNames("all", sty.freeBox__nwCvB)}>
            <div className={classNames("all", sty.freeBox___73EGw)}>
              <div className={classNames("all", "__wab_text", sty.text__stUfq)}>
                {"Pen\u00edze na \u00fa\u010det\n"}
              </div>
              <div className={classNames("all", "__wab_text", sty.text__gDv)}>
                {"Rychle a snadno\n"}
              </div>
            </div>
            <div className={classNames("all", sty.freeBox__jxkc8)}>
              <div className={classNames("all", sty.freeBox__y7DBr)}>
                <div className={classNames("all", sty.freeBox___6Hn0C)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__otnYc)}
                    displayHeight={"70px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"70px"}
                    loading={"lazy"}
                    src={{
                      src: "/plasmic/oblibena/images/imgP1Svg.svg",
                      fullWidth: 70,
                      fullHeight: 70,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames("all", "__wab_text", sty.text__fyk4A)}
                  >
                    <React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                        }
                        style={{ fontWeight: 700 }}
                      >
                        {"Do 5 minut"}
                      </span>
                      <React.Fragment>
                        {" v\u00edte, jestli p\u016fj\u010dku dostanete\n"}
                      </React.Fragment>
                    </React.Fragment>
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__fz7Qq)}
                  >
                    {
                      "V\u00e1\u017e\u00edme si va\u0161eho \u010dasu, a proto rozhodneme o va\u0161\u00ed \u017e\u00e1dosti za mi\u0148 ne\u017e 5 minut.\n"
                    }
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox__dt8NZ)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__mqlR6)}
                    displayHeight={"70px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"70px"}
                    loading={"lazy"}
                    src={{
                      src: "/plasmic/oblibena/images/imgP2Svg.svg",
                      fullWidth: 70,
                      fullHeight: 70,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames("all", "__wab_text", sty.text__nf8Bc)}
                  >
                    <React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                        }
                        style={{ fontWeight: 700 }}
                      >
                        {"Nejjednodu\u0161\u0161\u00ed"}
                      </span>
                      <React.Fragment>
                        {" \u017e\u00e1dost o p\u016fj\u010dku jen u n\u00e1s"}
                      </React.Fragment>
                    </React.Fragment>
                  </div>
                  <div
                    className={classNames("all", "__wab_text", sty.text__kn6Yc)}
                  >
                    {
                      "P\u0159edschvalov\u00e1c\u00ed \u017e\u00e1dost o Obl\u00edbenou p\u016fj\u010dku zvl\u00e1dnete kompletn\u011b vyplnit za 1 minutu."
                    }
                  </div>
                </div>
                <div className={classNames("all", sty.freeBox__thfjv)}>
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__qj1DT)}
                    displayHeight={"70px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"70px"}
                    loading={"lazy"}
                    src={{
                      src: "/plasmic/oblibena/images/imgP3Svg.svg",
                      fullWidth: 70,
                      fullHeight: 70,
                      aspectRatio: undefined
                    }}
                  />

                  <div
                    className={classNames("all", "__wab_text", sty.text__zQfY)}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {"Pen\u00edze na \u00fa\u010det "}
                      </React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                        }
                        style={{ fontWeight: 700 }}
                      >
                        {"ihned"}
                      </span>
                      <React.Fragment>
                        {" po schv\u00e1len\u00ed"}
                      </React.Fragment>
                    </React.Fragment>
                  </div>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text___9BMzq
                    )}
                  >
                    {
                      "V\u00edme, \u017ee v\u017edycky jde o \u010das a proto pen\u00edze klient\u016fm pos\u00edl\u00e1me ihned po schv\u00e1len\u00ed."
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"faq"}
            data-plasmic-override={overrides.faq}
            className={classNames("all", sty.faq)}
          >
            <div className={classNames("all", sty.freeBox__oXknl)}>
              <div className={classNames("all", "__wab_text", sty.text__cn2Eb)}>
                <React.Fragment>
                  <React.Fragment>{"Nej\u010dast\u011bji "}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                    }
                    style={{ color: "var(--token-zE3McqNVbf1u)" }}
                  >
                    {"kladen\u00e9 dotazy"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                    }
                    style={{ color: "var(--token-zE3McqNVbf1u)" }}
                  >
                    {"ohledn\u011b p\u016fj\u010dek"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                </React.Fragment>
              </div>
              {(() => {
                const child$Props = {
                  activeKey: generateStateValueProp($state, [
                    "accordion",
                    "activePanelId"
                  ]),
                  bordered: false,
                  className: classNames("__wab_instance", sty.accordion),
                  expandIcon: null,
                  expandIconPosition: "end",
                  forceRender: true,
                  ghost: true,
                  items: (
                    <React.Fragment>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__t7AYg
                        )}
                        extra={
                          <button
                            className={classNames(
                              "all",
                              "button",
                              "button__dpdRo",
                              sty.button__uaW63
                            )}
                            onClick={async event => {
                              const $steps = {};

                              $steps["updateAccordionActivePanelId"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "accordion",
                                          "activePanelId"
                                        ]
                                      },
                                      operation: 0,
                                      value: "1"
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateAccordionActivePanelId"] !=
                                  null &&
                                typeof $steps[
                                  "updateAccordionActivePanelId"
                                ] === "object" &&
                                typeof $steps["updateAccordionActivePanelId"]
                                  .then === "function"
                              ) {
                                $steps["updateAccordionActivePanelId"] =
                                  await $steps["updateAccordionActivePanelId"];
                              }
                            }}
                            type={"button"}
                          >
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "1";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__t2Qq2)}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "1";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__v3Br)}
                                role={"img"}
                              />
                            ) : null}
                          </button>
                        }
                        headerClass={classNames({
                          [sty["pcls_qKW-EfLEcZge"]]: true
                        })}
                        id={"1"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__pLdns
                            )}
                          >
                            {"Mohu si p\u016fj\u010dit na cokoliv?"}
                          </div>
                        }
                        showArrow={false}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__oLgHv
                          )}
                        >
                          {
                            "Ano, m\u016f\u017eete si p\u016fj\u010dit na cokoliv, co pot\u0159ebujete. Nezkoum\u00e1me \u00fa\u010del va\u0161\u00ed p\u016fj\u010dky, a proto nen\u00ed nutn\u00e9 n\u00e1m nic dokl\u00e1dat. Pen\u00edze m\u016f\u017eete vyu\u017e\u00edt nap\u0159\u00edklad na rekonstrukci bydlen\u00ed, koupi automobilu, financov\u00e1n\u00ed dovolen\u00e9, n\u00e1kup elektroniky, vzd\u011bl\u00e1n\u00ed nebo dokonce na konsolidaci st\u00e1vaj\u00edc\u00edch dluh\u016f. Rozhodnut\u00ed je jen na v\u00e1s."
                          }
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__aSf1N
                        )}
                        extra={
                          <button
                            className={classNames(
                              "all",
                              "button",
                              "button__dpdRo",
                              sty.button__qjaW6
                            )}
                            onClick={async event => {
                              const $steps = {};

                              $steps["updateAccordionActivePanelId"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "accordion",
                                          "activePanelId"
                                        ]
                                      },
                                      operation: 0,
                                      value: "1"
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateAccordionActivePanelId"] !=
                                  null &&
                                typeof $steps[
                                  "updateAccordionActivePanelId"
                                ] === "object" &&
                                typeof $steps["updateAccordionActivePanelId"]
                                  .then === "function"
                              ) {
                                $steps["updateAccordionActivePanelId"] =
                                  await $steps["updateAccordionActivePanelId"];
                              }
                            }}
                            type={"button"}
                          >
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "2";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__mrcSa)}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "2";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__fUBr5)}
                                role={"img"}
                              />
                            ) : null}
                          </button>
                        }
                        headerClass={classNames({
                          [sty["pcls_Kpeb8nuo-aky"]]: true
                        })}
                        id={"2"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__zTpvP
                            )}
                          >
                            {
                              "Co mus\u00edm spl\u0148ovat pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky?"
                            }
                          </div>
                        }
                        showArrow={false}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__qvvwQ
                          )}
                        >
                          {
                            "Pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky je nutn\u00e9 splnit n\u011bkolik z\u00e1kladn\u00edch podm\u00ednek. Tato p\u016fj\u010dka je ur\u010dena ob\u010dan\u016fm s trval\u00fdm pobytem na \u00fazem\u00ed \u010cesk\u00e9 republiky, kte\u0159\u00ed maj\u00ed pravideln\u00fd p\u0159\u00edjem a vlastn\u00ed bankovn\u00ed \u00fa\u010det, na kter\u00fd budou finance vyplaceny. D\u016fle\u017eit\u00e9 je tak\u00e9 spl\u0148ovat v\u011bkovou hranici, kter\u00e1 je stanovena na 18 a\u017e 75 let. Krom\u011b t\u011bchto podm\u00ednek je pot\u0159eba m\u00edt schopnost \u0159\u00e1dn\u011b spl\u00e1cet p\u016fj\u010dku dle sjednan\u00fdch podm\u00ednek."
                          }
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__ksf6Q
                        )}
                        extra={
                          <button
                            className={classNames(
                              "all",
                              "button",
                              "button__dpdRo",
                              sty.button__zdgEz
                            )}
                            onClick={async event => {
                              const $steps = {};

                              $steps["updateAccordionActivePanelId"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "accordion",
                                          "activePanelId"
                                        ]
                                      },
                                      operation: 0,
                                      value: "1"
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateAccordionActivePanelId"] !=
                                  null &&
                                typeof $steps[
                                  "updateAccordionActivePanelId"
                                ] === "object" &&
                                typeof $steps["updateAccordionActivePanelId"]
                                  .then === "function"
                              ) {
                                $steps["updateAccordionActivePanelId"] =
                                  await $steps["updateAccordionActivePanelId"];
                              }
                            }}
                            type={"button"}
                          >
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "3";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__frX0K)}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "3";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__c7Jno)}
                                role={"img"}
                              />
                            ) : null}
                          </button>
                        }
                        headerClass={classNames({
                          [sty["pcls_Xxv1efMyqHEp"]]: true
                        })}
                        id={"3"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__kNmr4
                            )}
                          >
                            {
                              "Jsou s\u202fvy\u0159\u00edzen\u00edm p\u016fj\u010dky spojeny n\u011bjak\u00e9 poplatky?"
                            }
                          </div>
                        }
                        showArrow={false}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___9TaqQ
                          )}
                        >
                          {
                            "Ne, za schv\u00e1len\u00ed p\u016fj\u010dky se neplat\u00ed \u017e\u00e1dn\u00e9 poplatky. U n\u00e1s ne\u00fa\u010dtujeme \u017e\u00e1dn\u00e9 skryt\u00e9 n\u00e1klady za samotn\u00e9 pod\u00e1n\u00ed \u017e\u00e1dosti nebo proces schv\u00e1len\u00ed. M\u016f\u017eete si b\u00fdt jisti, \u017ee cel\u00fd proces je transparentn\u00ed a v\u0161echny podm\u00ednky jsou p\u0159edem jasn\u011b stanoven\u00e9. Poplatky, pokud n\u011bjak\u00e9 existuj\u00ed, se mohou vztahovat pouze na veden\u00ed \u00fav\u011bru, p\u0159\u00edpadn\u00e9 prodlou\u017een\u00ed splatnosti nebo jin\u00e9 slu\u017eby, kter\u00e9 si dobrovoln\u011b zvol\u00edte. Tyto poplatky jsou v\u017edy uvedeny ve smlouv\u011b, abyste m\u011bli p\u0159esn\u00fd p\u0159ehled o v\u0161ech n\u00e1kladech spojen\u00fdch s va\u0161\u00ed p\u016fj\u010dkou."
                          }
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__nx4Ny
                        )}
                        extra={
                          <button
                            className={classNames(
                              "all",
                              "button",
                              "button__dpdRo",
                              sty.button__r68Ie
                            )}
                            onClick={async event => {
                              const $steps = {};

                              $steps["updateAccordionActivePanelId"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "accordion",
                                          "activePanelId"
                                        ]
                                      },
                                      operation: 0,
                                      value: "1"
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateAccordionActivePanelId"] !=
                                  null &&
                                typeof $steps[
                                  "updateAccordionActivePanelId"
                                ] === "object" &&
                                typeof $steps["updateAccordionActivePanelId"]
                                  .then === "function"
                              ) {
                                $steps["updateAccordionActivePanelId"] =
                                  await $steps["updateAccordionActivePanelId"];
                              }
                            }}
                            type={"button"}
                          >
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "4";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__hrkef)}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "4";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__z7HPx)}
                                role={"img"}
                              />
                            ) : null}
                          </button>
                        }
                        headerClass={classNames({
                          [sty["pcls_wD3qCvGydY_C"]]: true
                        })}
                        id={"4"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text___4LzZe
                            )}
                          >
                            {
                              "Jak\u00e9 doklady mus\u00edm p\u0159edlo\u017eit, abych z\u00edskal/a p\u016fj\u010dku?"
                            }
                          </div>
                        }
                        showArrow={false}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__uKPux
                          )}
                        >
                          {
                            "Pro schv\u00e1len\u00ed p\u016fj\u010dky je v\u017edy nutn\u00e9 dolo\u017eit n\u011bkolik z\u00e1kladn\u00edch dokument\u016f, kter\u00e9 slou\u017e\u00ed k ov\u011b\u0159en\u00ed va\u0161\u00ed toto\u017enosti a finan\u010dn\u00ed situace. Pat\u0159\u00ed mezi n\u011b:\nKopie platn\u00e9ho ob\u010dansk\u00e9ho pr\u016fkazu.\nKopie druh\u00e9ho dokladu toto\u017enosti (nap\u0159. \u0159idi\u010dsk\u00fd pr\u016fkaz, cestovn\u00ed pas nebo rodn\u00fd list).\nV\u00fdplatn\u00ed p\u00e1sky za posledn\u00ed 3 m\u011bs\u00edce nebo v\u00fdpisy z bankovn\u00edho \u00fa\u010dtu za posledn\u00ed 3 m\u011bs\u00edce, kter\u00e9 prokazuj\u00ed v\u00e1\u0161 pravideln\u00fd p\u0159\u00edjem.\n\nKrom\u011b t\u011bchto dokument\u016f m\u016f\u017ee b\u00fdt v n\u011bkter\u00fdch p\u0159\u00edpadech poskytovatelem p\u016fj\u010dky vy\u017eadov\u00e1no tak\u00e9 potvrzen\u00ed o trval\u00e9m pobytu nebo doklad o vlastnictv\u00ed bankovn\u00edho \u00fa\u010dtu, na kter\u00fd budou pen\u00edze vyplaceny. D\u016fle\u017eit\u00e9 je, aby v\u0161echny dokumenty byly aktu\u00e1ln\u00ed, co\u017e urychl\u00ed proces schv\u00e1len\u00ed va\u0161\u00ed p\u016fj\u010dky."
                          }
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem___4ISpm
                        )}
                        extra={
                          <button
                            className={classNames(
                              "all",
                              "button",
                              "button__dpdRo",
                              sty.button__uIlNv
                            )}
                            onClick={async event => {
                              const $steps = {};

                              $steps["updateAccordionActivePanelId"] = true
                                ? (() => {
                                    const actionArgs = {
                                      variable: {
                                        objRoot: $state,
                                        variablePath: [
                                          "accordion",
                                          "activePanelId"
                                        ]
                                      },
                                      operation: 0,
                                      value: "1"
                                    };
                                    return (({
                                      variable,
                                      value,
                                      startIndex,
                                      deleteCount
                                    }) => {
                                      if (!variable) {
                                        return;
                                      }
                                      const { objRoot, variablePath } =
                                        variable;

                                      $stateSet(objRoot, variablePath, value);
                                      return value;
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["updateAccordionActivePanelId"] !=
                                  null &&
                                typeof $steps[
                                  "updateAccordionActivePanelId"
                                ] === "object" &&
                                typeof $steps["updateAccordionActivePanelId"]
                                  .then === "function"
                              ) {
                                $steps["updateAccordionActivePanelId"] =
                                  await $steps["updateAccordionActivePanelId"];
                              }
                            }}
                            type={"button"}
                          >
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "5";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__aeHfx)}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "5";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__ks2Ka)}
                                role={"img"}
                              />
                            ) : null}
                          </button>
                        }
                        headerClass={classNames({
                          [sty["pcls_xQ-6tpawp-da"]]: true
                        })}
                        id={"5"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text___5He8E
                            )}
                          >
                            {
                              "Dostanu p\u016fj\u010dku p\u0159\u00edmo od va\u0161\u00ed spole\u010dnosti?"
                            }
                          </div>
                        }
                        showArrow={false}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__zx1Tj
                          )}
                        >
                          {
                            "Na\u0161e spole\u010dnost vystupuje jako zprost\u0159edkovatel mezi v\u00e1mi a \u00fav\u011brov\u00fdmi spole\u010dnostmi, kter\u00e9 v\u00e1m mohou p\u016fj\u010dku poskytnout. Po vypln\u011bn\u00ed \u017e\u00e1dosti ode\u0161leme v\u00e1\u0161 po\u017eadavek n\u011bkolika \u00fav\u011brov\u00fdm spole\u010dnostem a po obdr\u017een\u00ed odpov\u011bd\u00ed v\u00e1s nasm\u011brujeme na tu spole\u010dnost, kter\u00e1 m\u00e1 nejv\u011bt\u0161\u00ed pravd\u011bpodobnost v\u00e1m p\u016fj\u010dku skute\u010dn\u011b schv\u00e1lit."
                          }
                        </div>
                      </AntdAccordionItem>
                    </React.Fragment>
                  ),
                  onChange: async (...eventArgs: any) => {
                    generateStateOnChangePropForCodeComponents(
                      $state,
                      "activePanelId",
                      ["accordion", "activePanelId"],
                      AntdAccordion_Helpers
                    ).apply(null, eventArgs);
                  },
                  rotationAngle: 90
                };
                initializeCodeComponentStates(
                  $state,
                  [
                    {
                      name: "activePanelId",
                      plasmicStateName: "accordion.activePanelId"
                    }
                  ],
                  [],
                  AntdAccordion_Helpers ?? {},
                  child$Props
                );

                return (
                  <AntdAccordion
                    data-plasmic-name={"accordion"}
                    data-plasmic-override={overrides.accordion}
                    {...child$Props}
                  />
                );
              })()}
            </div>
          </div>
          <div
            data-plasmic-name={"reviews"}
            data-plasmic-override={overrides.reviews}
            className={classNames("all", sty.reviews)}
          >
            <div className={classNames("all", sty.freeBox__lRuE6)}>
              <div
                className={classNames("all", "__wab_text", sty.text___9TdnJ)}
              >
                <React.Fragment>
                  <React.Fragment>{"Co \u0159\u00edkaj\u00ed "}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                    }
                    style={{ color: "var(--token-zE3McqNVbf1u)" }}
                  >
                    {"na\u0161i"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__dpdRo"
                    }
                    style={{ color: "var(--token-zE3McqNVbf1u)" }}
                  >
                    {"klienti"}
                  </span>
                </React.Fragment>
              </div>
            </div>
            <div className={classNames("all", sty.freeBox__gwptl)}>
              {(() => {
                const child$Props = {
                  arrowColor: true ? "#DC2626" : undefined,
                  arrows: false,
                  beforeChange: async (...eventArgs: any) => {
                    generateStateOnChangePropForCodeComponents(
                      $state,
                      "currentSlide",
                      ["sliderCarousel", "currentSlide"],
                      SliderWrapper_Helpers
                    ).apply(null, eventArgs);
                  },
                  className: classNames("__wab_instance", sty.sliderCarousel),
                  draggable: false,
                  fade: true,
                  infinite: false,
                  initialSlide: generateStateValueProp($state, [
                    "sliderCarousel",
                    "currentSlide"
                  ]),
                  pauseOnHover: false,
                  ref: ref => {
                    $refs["sliderCarousel"] = ref;
                  },
                  sliderScopeClassName: sty["sliderCarousel__slider"],
                  speed: 500,
                  swipe: false,
                  touchMove: false
                };
                initializeCodeComponentStates(
                  $state,
                  [
                    {
                      name: "currentSlide",
                      plasmicStateName: "sliderCarousel.currentSlide"
                    }
                  ],
                  [],
                  SliderWrapper_Helpers ?? {},
                  child$Props
                );

                return (
                  <SliderWrapper
                    data-plasmic-name={"sliderCarousel"}
                    data-plasmic-override={overrides.sliderCarousel}
                    {...child$Props}
                  >
                    <div
                      data-plasmic-name={"reviewSlide"}
                      data-plasmic-override={overrides.reviewSlide}
                      className={classNames("all", sty.reviewSlide)}
                    >
                      <div className={classNames("all", sty.freeBox__l5XRa)}>
                        <div className={classNames("all", sty.freeBox__pdyBi)}>
                          <div
                            data-plasmic-name={"reviewCard"}
                            data-plasmic-override={overrides.reviewCard}
                            className={classNames("all", sty.reviewCard)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__njSsk
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Vždy jsem byl skeptický k online půjčkám, ale tento proces byl tak jednoduchý a rychlý! Peníze byly na mém účtu do 20 minut. Díky!"
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox__grnnj)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__wFag)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                quality={75}
                                src={{
                                  src: "/plasmic/oblibena/images/jirkaPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__fRsjD
                                )}
                              >
                                <React.Fragment>{"Jirka, 39"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"reviewCard2"}
                            data-plasmic-override={overrides.reviewCard2}
                            className={classNames("all", sty.reviewCard2)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text___8FgbC
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Překvapilo mě, jak snadné a transparentní to bylo. Žádné skryté poplatky, vše jasné a srozumitelné. Doporučuji všem v nouzi."
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox__lmXnu)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__sLb3C)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                src={{
                                  src: "/plasmic/oblibena/images/ondraPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__avAz0
                                )}
                              >
                                <React.Fragment>{"Ondra, 44"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"reviewSlide2"}
                      data-plasmic-override={overrides.reviewSlide2}
                      className={classNames("all", sty.reviewSlide2)}
                    >
                      <div className={classNames("all", sty.freeBox__tiz6H)}>
                        <div className={classNames("all", sty.freeBox__lGwEm)}>
                          <div
                            data-plasmic-name={"reviewCard3"}
                            data-plasmic-override={overrides.reviewCard3}
                            className={classNames("all", sty.reviewCard3)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text___9DmS
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Když jsem potřebovala peníze nejvíce, tato online půjčka mi přišla jako záchraná brzda. Rychlá, jednoduchá a bez stresu."
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox___5UFwc)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img___2HlXl)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                src={{
                                  src: "/plasmic/oblibena/images/hanaPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text___97BmZ
                                )}
                              >
                                <React.Fragment>{"Hana, 51"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"reviewCard4"}
                            data-plasmic-override={overrides.reviewCard4}
                            className={classNames("all", sty.reviewCard4)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__rkNo3
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Skvělá zkušenost! Vše proběhlo hladce a komunikace byla na výbornou. Cítím se, jako bych získal nového finančního partnera."
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox__wqrBk)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__xcWYr)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                src={{
                                  src: "/plasmic/oblibena/images/ottoPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__iCMmM
                                )}
                              >
                                <React.Fragment>{"Otto, 46"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-plasmic-name={"reviewSlide3"}
                      data-plasmic-override={overrides.reviewSlide3}
                      className={classNames("all", sty.reviewSlide3)}
                    >
                      <div className={classNames("all", sty.freeBox___19LSm)}>
                        <div className={classNames("all", sty.freeBox__fJqtq)}>
                          <div
                            data-plasmic-name={"reviewCard5"}
                            data-plasmic-override={overrides.reviewCard5}
                            className={classNames("all", sty.reviewCard5)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__hHegW
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Půjčka mi pomohla překlenout těžké období. Vše proběhlo rychle a bez zbytečných komplikací. Díky za pomoc!"
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox___3KV26)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img___7HwUl)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                src={{
                                  src: "/plasmic/oblibena/images/katkaPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__n8SMg
                                )}
                              >
                                <React.Fragment>{"Katka, 62"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"reviewCard6"}
                            data-plasmic-override={overrides.reviewCard6}
                            className={classNames("all", sty.reviewCard6)}
                          >
                            <div
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.text__gn4Q6
                              )}
                            >
                              <React.Fragment>
                                {
                                  "Měl jsem již zkušenosti s online půjčkami, ale tato byla zdaleka nejlepší. Rychlé schválení a bez skrytých poplatků."
                                }
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames("all", sty.freeBox__y6ACo)}
                            >
                              <PlasmicImg__
                                alt={""}
                                className={classNames(sty.img__got7T)}
                                displayHeight={"30px"}
                                displayMaxHeight={"none"}
                                displayMaxWidth={"100%"}
                                displayMinHeight={"0"}
                                displayMinWidth={"0"}
                                displayWidth={"30px"}
                                height={"30px"}
                                loading={"lazy"}
                                src={{
                                  src: "/plasmic/oblibena/images/milosPng.png",
                                  fullWidth: 300,
                                  fullHeight: 300,
                                  aspectRatio: undefined
                                }}
                                width={"30px"}
                              />

                              <div
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.text__wXbaF
                                )}
                              >
                                <React.Fragment>{"Miloš, 45"}</React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SliderWrapper>
                );
              })()}
            </div>
          </div>
          <div className={classNames("all", sty.freeBox__rjeTk)}>
            <div className={classNames("all", sty.freeBox__zy3UP)}>
              <SliderBtn
                className={classNames("__wab_instance", sty.sliderBtn__mlCls)}
                inactive={(() => {
                  try {
                    return $state.sliderCarousel.currentSlide !== 0;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()}
                onClick={async () => {
                  const $steps = {};

                  $steps["updateSliderCarouselCurrentSlide"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["sliderCarousel", "currentSlide"]
                          },
                          operation: 0,
                          value: 0
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateSliderCarouselCurrentSlide"] != null &&
                    typeof $steps["updateSliderCarouselCurrentSlide"] ===
                      "object" &&
                    typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                      "function"
                  ) {
                    $steps["updateSliderCarouselCurrentSlide"] =
                      await $steps["updateSliderCarouselCurrentSlide"];
                  }
                }}
              />

              <SliderBtn
                className={classNames("__wab_instance", sty.sliderBtn__dxZ9E)}
                inactive={(() => {
                  try {
                    return $state.sliderCarousel.currentSlide !== 1;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()}
                onClick={async () => {
                  const $steps = {};

                  $steps["updateSliderCarouselCurrentSlide"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["sliderCarousel", "currentSlide"]
                          },
                          operation: 0,
                          value: 1
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateSliderCarouselCurrentSlide"] != null &&
                    typeof $steps["updateSliderCarouselCurrentSlide"] ===
                      "object" &&
                    typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                      "function"
                  ) {
                    $steps["updateSliderCarouselCurrentSlide"] =
                      await $steps["updateSliderCarouselCurrentSlide"];
                  }
                }}
              />

              <SliderBtn
                className={classNames("__wab_instance", sty.sliderBtn__fbd5Y)}
                inactive={(() => {
                  try {
                    return $state.sliderCarousel.currentSlide !== 2;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()}
                onClick={async () => {
                  const $steps = {};

                  $steps["updateSliderCarouselCurrentSlide"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["sliderCarousel", "currentSlide"]
                          },
                          operation: 0,
                          value: 2
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateSliderCarouselCurrentSlide"] != null &&
                    typeof $steps["updateSliderCarouselCurrentSlide"] ===
                      "object" &&
                    typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                      "function"
                  ) {
                    $steps["updateSliderCarouselCurrentSlide"] =
                      await $steps["updateSliderCarouselCurrentSlide"];
                  }
                }}
              />
            </div>
          </div>
          <div className={classNames("all", sty.freeBox__qDp3)}>
            <div className={classNames("all", sty.freeBox__fys94)}>
              <LGCTAButton
                amount={$state.amount}
                buttonSlot={
                  <PrimaryButton
                    className={classNames(
                      "__wab_instance",
                      sty.primaryButton__eytHu
                    )}
                    label={
                      <div
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.text__hJHw
                        )}
                      >
                        {"Z\u00cdSKAT PEN\u00cdZE"}
                      </div>
                    }
                  />
                }
                className={classNames("__wab_instance", sty.lgctaButton__zKmDn)}
                id={"cta-btn-2"}
              />
            </div>
          </div>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer)}
          />

          <BackToTop
            data-plasmic-name={"backToTop"}
            data-plasmic-override={overrides.backToTop}
            className={classNames("__wab_instance", sty.backToTop)}
          >
            <div className={classNames("all", sty.freeBox__n1Xx8)}>
              <ChevronDownIcon
                className={classNames("all", sty.svg__pv3U6)}
                role={"img"}
              />
            </div>
          </BackToTop>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  homePageWrapper: [
    "homePageWrapper",
    "lgPresetMessage",
    "header",
    "slider",
    "faq",
    "accordion",
    "reviews",
    "sliderCarousel",
    "reviewSlide",
    "reviewCard",
    "reviewCard2",
    "reviewSlide2",
    "reviewCard3",
    "reviewCard4",
    "reviewSlide3",
    "reviewCard5",
    "reviewCard6",
    "footer",
    "backToTop"
  ],
  lgPresetMessage: ["lgPresetMessage"],
  header: ["header", "slider"],
  slider: ["slider"],
  faq: ["faq", "accordion"],
  accordion: ["accordion"],
  reviews: [
    "reviews",
    "sliderCarousel",
    "reviewSlide",
    "reviewCard",
    "reviewCard2",
    "reviewSlide2",
    "reviewCard3",
    "reviewCard4",
    "reviewSlide3",
    "reviewCard5",
    "reviewCard6"
  ],
  sliderCarousel: [
    "sliderCarousel",
    "reviewSlide",
    "reviewCard",
    "reviewCard2",
    "reviewSlide2",
    "reviewCard3",
    "reviewCard4",
    "reviewSlide3",
    "reviewCard5",
    "reviewCard6"
  ],
  reviewSlide: ["reviewSlide", "reviewCard", "reviewCard2"],
  reviewCard: ["reviewCard"],
  reviewCard2: ["reviewCard2"],
  reviewSlide2: ["reviewSlide2", "reviewCard3", "reviewCard4"],
  reviewCard3: ["reviewCard3"],
  reviewCard4: ["reviewCard4"],
  reviewSlide3: ["reviewSlide3", "reviewCard5", "reviewCard6"],
  reviewCard5: ["reviewCard5"],
  reviewCard6: ["reviewCard6"],
  footer: ["footer"],
  backToTop: ["backToTop"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  homePageWrapper: "div";
  lgPresetMessage: typeof LGPresetMessage;
  header: "div";
  slider: typeof Slider;
  faq: "div";
  accordion: typeof AntdAccordion;
  reviews: "div";
  sliderCarousel: typeof SliderWrapper;
  reviewSlide: "div";
  reviewCard: "div";
  reviewCard2: "div";
  reviewSlide2: "div";
  reviewCard3: "div";
  reviewCard4: "div";
  reviewSlide3: "div";
  reviewCard5: "div";
  reviewCard6: "div";
  footer: typeof Footer;
  backToTop: typeof BackToTop;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "homePageWrapper") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("homePageWrapper"),
  {
    // Helper components rendering sub-elements
    lgPresetMessage: makeNodeComponent("lgPresetMessage"),
    header: makeNodeComponent("header"),
    slider: makeNodeComponent("slider"),
    faq: makeNodeComponent("faq"),
    accordion: makeNodeComponent("accordion"),
    reviews: makeNodeComponent("reviews"),
    sliderCarousel: makeNodeComponent("sliderCarousel"),
    reviewSlide: makeNodeComponent("reviewSlide"),
    reviewCard: makeNodeComponent("reviewCard"),
    reviewCard2: makeNodeComponent("reviewCard2"),
    reviewSlide2: makeNodeComponent("reviewSlide2"),
    reviewCard3: makeNodeComponent("reviewCard3"),
    reviewCard4: makeNodeComponent("reviewCard4"),
    reviewSlide3: makeNodeComponent("reviewSlide3"),
    reviewCard5: makeNodeComponent("reviewCard5"),
    reviewCard6: makeNodeComponent("reviewCard6"),
    footer: makeNodeComponent("footer"),
    backToTop: makeNodeComponent("backToTop"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
